import { isClerkEnabled } from '../config/clerk';
import ClerkCheckout from './ClerkCheckout';
import LegacyCheckout from './LegacyCheckout';

const Checkout = () => (isClerkEnabled ? <ClerkCheckout /> : <LegacyCheckout />);

export default Checkout;
